import {Component, Inject, Input} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogButtonTypesEnum, DialogConfigInterface} from 'appShared/components';
import {ApiError, MarketDataFeedBundleModel, SesService} from '@spa/api';
import {PermissionRuleInterface} from 'appShared/interfaces';
import {RemoveFeedBundleForm} from 'appEntries/panel/forms';
import {MarketDataFeedsAddMessages} from 'appAssets/messages';
import {AlertsService} from 'appShared/services';
import {MarketDataFeedBundleFormErrorStatesEnum} from 'appEntries/panel/enums';
import {MarketDataFeedAndBundleDeleteInterface} from 'appEntries/panel/interfaces';
import {PermissionRulesTrait} from 'appEntries/panel/traits';
import {PanelBaseMarketDataFormDialogComponent} from 'appEntries/panel/dialogs/ses/panel-base-market-data-form-dialog.component';

@Component({
    selector: 'app-market-data-remove-existing-bundle-feeds',
    templateUrl: './market-data-remove-existing-bundle-feeds.component.html'
})
export class MarketDataRemoveExistingBundleFeedsComponent
    extends PanelBaseMarketDataFormDialogComponent<MarketDataRemoveExistingBundleFeedsComponent> {

    public viewFeedPermissionRule: PermissionRuleInterface;
    public manageBundlePermissionRule: PermissionRuleInterface;

    @Input() public feeds: MarketDataFeedAndBundleDeleteInterface[];
    @Input() public bundle: MarketDataFeedBundleModel;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            feeds: MarketDataFeedAndBundleDeleteInterface[],
            bundle: MarketDataFeedBundleModel
        },
        private readonly sesService: SesService,
        protected alertsService: AlertsService,
        public dialogRef: MatDialogRef<MarketDataRemoveExistingBundleFeedsComponent>,
    ) {
        super(dialogRef, alertsService);
        this.manageBundlePermissionRule = PermissionRulesTrait.getMarketDataFeedBundleManagementPermissionRule();
        this.viewFeedPermissionRule = PermissionRulesTrait.getMarketDataFeedViewPermissionRule();
        this.config = data.config;
        this.feeds = data.feeds;
        this.bundle = data.bundle;
    }

    initForm(): void {
        this.form = new RemoveFeedBundleForm(this.sesService, this.feeds, this.bundle);
        this.form.initForm();

        const formChangeSubscription = this.form.formGroup.valueChanges.subscribe((data: object) => {
            const selectedBundleFirstIndex = Object.keys(data).findIndex((key: string) => data[key] > 0);
            this.config.buttons.find(button => button.type === DialogButtonTypesEnum.Confirm).hidden = selectedBundleFirstIndex < 0;
        });

        this.subscriptions.push(formChangeSubscription);
    }

    getErrorMessageByApiError(error: ApiError): string {
        switch (error.status) {
            case MarketDataFeedBundleFormErrorStatesEnum.UpdateMarketDataFeedBundleFailed:
                return MarketDataFeedsAddMessages.UpdateMarketDataFeedBundleFailed.message;
            case MarketDataFeedBundleFormErrorStatesEnum.MarketDataFeedOfBundleRemoveFailedNeedToSelectMinFeed:
                return MarketDataFeedsAddMessages.MarketDataFeedOfBundleRemoveFailedNeedToSelectMinFeed.message;
            case MarketDataFeedBundleFormErrorStatesEnum.MarketDataFeedOfBundleRemoveFailedNeedToStayMinFeed:
                return MarketDataFeedsAddMessages.MarketDataFeedOfBundleRemoveFailedNeedToStayMinFeed.message;
            default:
                return MarketDataFeedsAddMessages.UnknownError.message;
        }
    }

    getSuccessFormMessage(): string {
        return MarketDataFeedsAddMessages.MarketDataFeedDeletionSucceed.message;
    }
}
